export default __webpack_public_path__ + "static/media/vip-5.feef2373.svg";